import React from 'react';
import styles from './styles.module.scss';
import Close from './gen_close.svg';

const Modal = ({
  children,
  handleClose,
  primaryBtnText,
  secondaryBtnText,
  primaryAction,
  secondaryAction,
  isOpen,
  overlayStyle,
  modalStyle,
}) => {
  return (
    <div className={styles.modalContainer}>
      {isOpen ? (
        <div className={styles.overlay} data-test="modal" style={overlayStyle}>
          <div className={styles.modalContent} style={modalStyle}>
            <img
              className={styles.closeBtn}
              src={Close}
              alt="close"
              onClick={handleClose}
              data-test="close"
            />
            <div data-test="children">{children}</div>
            <div className={styles.buttonsContainer}>
              <button
                className={styles.primaryBtn}
                onClick={primaryAction}
                data-test="primaryAction"
              >
                {primaryBtnText}
              </button>
              <button
                className={styles.secondaryBtn}
                onClick={secondaryAction}
                data-test="secondaryAction"
              >
                {secondaryBtnText}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Modal;
